import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 40px 16px;
  background: ${props => props.theme.brand_primary_color};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* o logo é de cada parceiro e pode ter qualquer proporção */
  .logo {
    width: 220px;
    max-width: 70%;
    max-height: 96px;
    object-fit: contain;
    margin-bottom: 40px;
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 40px 36px;
  border-radius: 12px;
  background: ${props => props.theme.interface1};

  form {
    display: flex;
    flex-direction: column;
  }

  a {
    font-weight: 700;
    color: ${props => props.theme.brand_primary_color};
  }

  @media (max-width: 480px) {
    padding: 32px 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
  text-align: center;

  img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }

  h1 {
    font-size: 20px;
    line-height: 28px;
    color: #a2a9bf;
    text-transform: uppercase;
  }

  p {
    margin-top: 4px;
    font-size: 13px;
    line-height: 20px;
    font-weight: 700;
    color: #a2a9bf;
  }
`;

// && sobe a especificidade para vencer o estilo padrão do CustomInput, usado em outras telas
export const Field = styled.div`
  margin-bottom: 20px;

  && input {
    font-size: 16px;
    border-width: 2px;
  }

  && .error {
    margin-top: 6px;
    font-size: 13px;
  }
`;

export const Footer = styled.div`
  margin-top: 28px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  font-size: 14px;
`;

export const RememberMe = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  margin-bottom: 28px;
  cursor: pointer;
  font-size: 15px;
  color: ${props =>
    props.theme.darkMode ? props.theme.interface4 : props.theme.interface5};

  input {
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    accent-color: ${props => props.theme.brand_primary_color};
  }
`;
